// Catálogos por defecto del módulo Mobiliario (el backend los complementa en /mobiliario/catalogos)
export const TIPOS_MOBILIARIO = [
  "Silla",
  "Mesa",
  "Escritorio",
  "Archivador",
  "Estante",
  "Armario",
  "Camilla",
  "Sofá",
  "Biombo",
  "Locker",
  "Otro",
];

export const ESTADOS_MOBILIARIO = ["Bueno", "Regular", "Malo", "Dado de baja"];

export const PROPIEDADES_MOBILIARIO = ["Propio", "Comodato", "Arrendado"];

export const ESTADO_BADGE = {
  Bueno: "bg-green-50 text-green-700 border border-green-200",
  Regular: "bg-amber-50 text-amber-700 border border-amber-200",
  Malo: "bg-red-50 text-red-700 border border-red-200",
  "Dado de baja": "bg-gray-100 text-gray-500 border border-gray-200",
};

export const toOptions = (lista) => lista.map((v) => ({ _id: v, name: v }));
